import useFacility from "../../../utils/hooks/useFacility";
import EAChip from "../shared/Chip/EAChip";
import "./style.scss";

export default function Download_PWA() {
  const facilityIds = useFacility();

  return (
    <>
      {(facilityIds === "1243" || facilityIds === "1243") && (
        <div className="download-pwa">
          <div className="download-pwa__left">
            <EAChip label="nowość" variant="success" />
            <h3>Pobierz naszą aplikację!  📲 </h3>
            <p>Kupuj bilety szybciej i wygodniej. Dodaj aplikację do ekranu głównego i loguj się błyskawicznie — zawsze pod ręką.</p>
    
          </div>
          <div className="download-pwa__right">
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://panel.eaktywni.pl/testApp/install-app?id=${facilityIds}`}
            className="button button--filled button--primary button--fullWidth "
            >
              Zainstaluj aplikację
            </a>

            {/* <EAButton startIcon={<IoMdCheckmark className="icon" />} title="Pobierz" fullWidth color="secondary" /> */}
          </div>
        </div>
      )}
    </>
  );
}
